import { Injectable } from '@angular/core';
import { CatFichaInmaterial } from '../models/CatFichaInmaterial';
import { URL_API } from '../global/config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FichaInmaterialService {

  private urlEndpoint: string = URL_API.UrlApi+'/api/v1/catfichasinmateriales';
  //private urlEndpoint: string = 'http://localhost:3000/api/v1/catfichasinmateriales';
  private httpHeaders = new HttpHeaders({'Content-Type': 'application/json'})
  //private catFichaInmaterial: CatFichaInmaterial;

  constructor(
    private http: HttpClient
  ) { }

  cargarFichasInmateriales(): Observable<CatFichaInmaterial[]> {
    return this.http.get<CatFichaInmaterial[]>(this.urlEndpoint);
  }

  crearFichaInmaterial(ficha: CatFichaInmaterial): Observable<CatFichaInmaterial>{
    return this.http.post<CatFichaInmaterial>(this.urlEndpoint, ficha, { headers: this.httpHeaders })
  }

  traerFichaInmaterial(id: Number): Observable<CatFichaInmaterial>{
    
    return this.http.get<CatFichaInmaterial>(`${this.urlEndpoint}/${id}`)
  }

  actualizarFichaInmaterial(ficha: CatFichaInmaterial): Observable<CatFichaInmaterial>{
    return this.http.put<CatFichaInmaterial>(`${this.urlEndpoint}/${ficha.id}`,ficha, { headers: this.httpHeaders})
  }

  //traer "Ficha Inmaterial" por "codregistro"

  traerFichaInmaterialPorCodregistro(codregistro: string): Observable<CatFichaInmaterial>{
    return this.http.get<CatFichaInmaterial>(`${this.urlEndpoint}/codregistro/${codregistro}`);

  }
  eliminarFichaInmaterial(id:Number): Observable<CatFichaInmaterial>{
    return this.http.delete<CatFichaInmaterial>(`${this.urlEndpoint}/${id}`,{headers: this.httpHeaders});
  }

}
